import React from 'react';
import './cookies.scss';

export const Cookies = (props) => {
  return props.trigger ? (
    <aside className="cookiesPopup">
      <div className="popup-inner">
        <p>
          Tento web používá k poskytování služeb, personalizaci reklam a analýze
          návštěvnosti soubory cookie. Používáním tohoto webu s tím souhlasíte.
        </p>
        <button
          className="popup-close_btn"
          onClick={() => props.setTrigger(false)}
        >
          Zavřít
        </button>
      </div>
    </aside>
  ) : (
    ''
  );
};
